// EXTERNAL
import { v4 as uuidv4 } from "uuid";
// CONFIGS
import config from "../configs/config";
// HELPERS
import { create_new_time_isostring } from "../helpers/format_time";
import { analytics_record } from "./amplify";
// TYPES
interface Logger {
  error: any;
  user: User;
  context: {
    origin: string;
    input?: string | undefined;
  };
}

interface User {
  id: string;
  firstName: string;
  lastName: string;
  teamId: string;
  teamName: string;
  email: string;
  type: string;
  filter: string;
  isAuthenticated: boolean;
}
export const logger = async ({ error, user, context }: Logger) => {
  if (config.environment !== "production") return;
  /**
   * HTL (13-07-23)
   * Error logging for any user on production site.
   */
  if (config.environment === "production") {
    analytics_record({
      name: uuidv4(),
      attributes: {
        eventType: "error",
        timestamp: create_new_time_isostring(),
        username: user.email,
        teamName: user.teamName,
        teamId: user.teamId,
        environment: config.environment,
        cause: error.cause,
        message: error.message,
        path: window.location.pathname,
        origin: context.origin,
        input: context.input || "n/a",
      },
    });
  }
};
